/* eslint-disable react/no-unknown-property */
import { useTranslation } from '@pypestream/translations';
import type { FC, ReactNode } from 'react';

import { callMeOffered } from './use-health-capabilities';

/**
 * Stands where "Call me" would be when the deployment has test calls off, so
 * the voice panel still says why it offers no call. Kept free of design-system
 * imports so it can be rendered under jsdom.
 */
export const VoiceCallsOffNote: FC = () => {
  const [t] = useTranslation();
  return (
    <div className="c-validate-call" test-id="bobcat-validate-call-off">
      <p className="c-validate-call__note" role="status">
        {String(t('pro-studio/common:voiceCalls.off'))}
      </p>
    </div>
  );
};

/**
 * The voice panel's call control: `children` (the "Call me" panel) where
 * `callMeOffered` says so; the off-note only for an explicit `false` (the
 * server said off); nothing while the answer is unknown (`undefined`:
 * pending or failed), since "could not find out" is not "turned off".
 */
export const VoiceCallGate: FC<{
  enabled: boolean | undefined;
  callInFlight: boolean;
  children: ReactNode;
}> = ({ enabled, callInFlight, children }) => {
  if (callMeOffered(enabled, callInFlight)) return <>{children}</>;
  return enabled === false ? <VoiceCallsOffNote /> : null;
};
